export enum OPERATION_COURRIER {
    IMPRESSION = 'IMPRESSION',
    COURRIEL = 'COURRIEL'
}
